import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";

const ContentRetentionInfoModal = ({
  open,
  large,
  handleClose,
  setPaymentMode,
}) => {
  const handleConfirm = () => {
    if (!large) {
      handleClose();
    } else {
      setPaymentMode(true);
      handleClose();
    }
  };
  return (
    <Box sx={{ width: "15vw !important" }}>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: {
              xs: "100%",
              sm: "409px",
            },
            borderRadius: "34px", // Apply 100px border radius to the dialog box
            overflow: "hidden", // Ensure content stays within rounded corners
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "24px 16px",
            display: "flex", // Use flexbox
            flexDirection: "column", // Stack items vertically
            alignItems: "center", // Center items horizontally
          }}
        >
          {/* Title */}
          <Box
            sx={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#F1F7FA",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Typography sx={{ fontSize: "30px" }}>i</Typography>
          </Box>
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="bold"
            gutterBottom
            sx={{
              padding: "0 15px",
              fontSize: "24px",
            }}
          >
            {large
              ? "Tier too large for your content library"
              : "Content library too large for this Tier"}
          </Typography>

          {/* Message */}
          <Typography
            sx={{
              padding: "0 15px",
              fontSize: "16px",
            }}
            variant="body2"
            color="#2A4876"
          >
            {large
              ? "Looks like you won’t be able to make full use of this tier as your content library is too small for this. Please try switching to a smaller tier."
              : "Your content library is too large for this tier. Archive or delete some items to purchase this one."}
          </Typography>

          {/* Buttons */}
          <Box
            mt={3}
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            gap={2}
          >
            <Button
              onClick={handleConfirm}
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#002A5C" },
              }}
            >
              {large === true ? "Continue with this tier" : "Okay"}
            </Button>
            {large && (
              <Button
                onClick={handleClose} // Confirms logout
                sx={{
                  textTransform: "none",
                  borderRadius: "34px",
                  backgroundColor: "#AAB6C8",
                  color: "#2A4876",
                  fontWeight: "bold",
                  padding: "12px 44px",
                  "&:hover": { backgroundColor: "#C4CED8" },
                }}
              >
                Choose a different tier
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ContentRetentionInfoModal;
